<template>
  <kst-modal-search
    :module="Model.Module"
    :moduleType="Model.ModuleType.SearchList"
    :searchData="searchData"
    :width="1000"
    @init="handleModal_init"
    @load="handleModal_load"
    @reset="handleModal_reset"
    @submit="handleModal_submit"
  >
    <template #search="{ handleInput }">
      <Search
        :searchData="searchData"
        :warehouseOptions="warehouseOptions"
        :status="status"
        @input="handleInput"
      />
    </template>

    <template #search-result="{ data, userData }">
      <List
        :dataList="data.InvoiceList"
        :userData="userData"
        :status="status"
      />
    </template>
  </kst-modal-search>
</template>

<script>
import Model from "../InvModel.js";
import SearchCatalog from "./SearchCatalog.js";

import List from "./InvScL_List.vue";
import Search from "./InvScL_Search.vue";

export default {
  components: {
    List,
    Search
  },
  props: {
    warehouseList: Array,
    // field visibility (alphabetical order)
    status: Boolean
  },
  data: () => ({
    Model: Model,
    searchData: {
      Search: "",
      Date: null,
      WarehouseID: null,
      StatusID: null
    },
    warehouseOptions: {},
    getDetailsService: null,
    getListService: null,
    // func
    hideFunc: null,
    showFunc: null
  }),
  methods: {
    /*** public method ***/

    show(getListService, getDetailsService) {
      this.getDetailsService = getDetailsService;
      this.getListService = getListService;
      this.showFunc();
    },

    /*** by modal ***/

    handleModal_init(show, hide) {
      this.showFunc = show;
      this.hideFunc = hide;
      this.resetData();

      this.$emit(this.$kst.Enum.Event.Init, this.show);
    },

    handleModal_load(loadList) {
      const options = this.getListOptions();
      const config = this.getListService(options);
      loadList(config);
    },

    handleModal_reset(loadList) {
      this.resetData();
      this.handleModal_load(loadList);
    },

    handleModal_submit(selected, loadDetails) {
      if (this.getDetailsService) {
        const config = this.getDetailsService(selected.ID);
        loadDetails(config, this.handleModal_submit_success);
      }
      else {
        this.$emit(this.$kst.Enum.Event.Submit, selected);
        this.hideFunc();
      }
    },
    handleModal_submit_success(data) {
      this.$emit(this.$kst.Enum.Event.Submit, data);
      this.hideFunc();
    },

    /*** custom ***/

    getListOptions() {
      return {
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID),
        status: this.$kst.Search.getValue(this.searchData.StatusID),
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1]),
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.SearchListFields
      };
    },

    resetData() {
      this.warehouseOptions = Model.getWarehouseOptions(
        this.warehouseList, SearchCatalog.WarehouseID.Label
      );

      // searchData
      this.searchData.Search = "";
      this.searchData.Date = this.$kst.In.getDefaultDateRange();
      this.searchData.WarehouseID = this.$kst.Search.OptionAll;
      this.searchData.StatusID = this.$kst.Search.OptionAll;
    }
  }
}
</script>